module.exports = __webpack_public_path__ + "img/page_cam_slider_02.eb7ae5ca.png";